import React from "react";

const QR = (props) => {
    return (
        <>QR</>
    )
}

export default QR;